import React, { useState, useEffect } from "react";

/**
 * Renders <img>. If the src is empty OR the image fails to load, shows a
 * graceful placeholder using the provided `name` (or a neutral tag).
 * Never displays the broken-image icon.
 *
 * Props: src, alt, name (fallback label), className (applied to img), fallbackClassName.
 */
export default function SafeImg({ src, alt = "", name = "", className = "", fallbackClassName = "", ...rest }) {
  const [broken, setBroken] = useState(false);
  useEffect(() => { setBroken(false); }, [src]);
  if (!src || broken) {
    return (
      <div
        data-testid="safe-img-fallback"
        className={`flex items-center justify-center bg-line/20 border border-dashed border-line/50 rounded ${className} ${fallbackClassName}`}
        aria-label={alt || name}
      >
        <span className="font-editorial text-ink/60 text-sm text-center px-3 truncate">
          {name || alt || "—"}
        </span>
      </div>
    );
  }
  return (
    <img
      src={src}
      alt={alt}
      className={className}
      loading="lazy"
      onError={() => setBroken(true)}
      {...rest}
    />
  );
}
